// CookiePrefsHelp.jsx
import React, { useMemo } from "react";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const CookiePrefsHelp = ({t}) => {
  

  const env = useMemo(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isMac = /Macintosh/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|Edg|OPR/.test(ua);
    const isChrome = /Chrome|CriOS/.test(ua) && !/Edg|OPR/.test(ua);

    return { isIOS, isMac, isSafari, isChrome };
  }, []);

  return (
    <div className="cookie-help">
      <h3>{t("cookiePrefsTitle")}</h3>

      {env.isChrome && !env.isIOS && (
        <ol>
          <li>{t("chrome1")}</li>
          <li>{t("chrome2")}</li>
          <li>{t("chrome3")}</li>
          <li>{t("chrome4")}</li>
        </ol>
      )}

      {env.isChrome && env.isIOS && (
        <ol>
          <li>{t("chromeIOS1")}</li>
          <li>{t("chromeIOS2")}</li>
          <li>{t("chromeIOS3")}</li>
        </ol>
      )}

      {env.isSafari && env.isMac && (
        <ol>
          <li>{t("safariMac1")}</li>
          <li>{t("safariMac2")}</li>
          <li>{t("safariMac3")}</li>
        </ol>
      )}

      {env.isSafari && env.isIOS && (
        <ol>
          <li>{t("safariIOS1")}</li>
          <li>{t("safariIOS2")}</li>
          <li>{t("safariIOS3")}</li>
        </ol>
      )}

      {!(env.isChrome || env.isSafari) && (
        <p>{t("otherBrowsers")}</p>
      )}

      <p className="cookie-help-note">{t("cookiePrefsNote")}</p>
    </div>
  );
};



export default CookiePrefsHelp